import React, { useState, useEffect } from 'react';
// import SearchBar from '../SearchBar';
import './styles.scss';
import { ActivitySearchWrapper } from '@share/components';
const Hero: React.FC = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [
    'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2021&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?q=80&w=2070&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2073&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1519046904884-53103b34b206?q=80&w=2070&auto=format&fit=crop'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index: number) => {
    setCurrentImageIndex(index);
  };

  /*   const onSearch=()=>{
  
    } */

  return (
    <div className="hero">
      {images.map((image, index) => (
        <div
          key={index}
          className={`hero__background ${index === currentImageIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
      <div className="hero__overlay" />
      <div className="hero__content">
        <h1 className="hero__title">Discover Your Next Adventure</h1>
        <p className="hero__subtitle">Find and book the best activities around the world</p>
        <ActivitySearchWrapper />
      </div>
      <div className="hero__dots">
        {images.map((_, index) => (
          <button
            key={index}
            className={`hero__dot ${index === currentImageIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Hero;
